import axios from "axios";

export const getCustomer = (id, callback) => {
    const config = {
        url: `/api/public/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

export const updateCustomerForms = (id, data, callback) => {
    const config = {
        url: `/api/public/${id}`,
        method: 'POST',
        data: data
    }

    axios.request(config)
        .then(response => callback({
            success: true,
            status: response.status,
        }))
        .catch(error => callback({
            success: false,
            status: error.response.status
        }));
}

export const getPublicForm = (publicId, data, callback) => {
    const config = {
        url: `/api/customerForms/${publicId}`,
        method: 'POST',
        data: data,
    }

    axios.request(config).then(response => callback(response.data));
}

export const updateCustomerFormData = (publicId, data, callback) => {
    const config = {
        url: `/api/customerForms/${publicId}`,
        method: 'PUT',
        data: data,
    }

    axios.request(config)
        .then(response => callback({
            success: true,
            status: response.status,
        }))
        .catch(error => callback({
            success: false,
            status: error.response.status
        }));
}

export const clearCustomerFormData = (publicId, data, callback) => {
    const config = {
        url: `/api/customerForms/clear/${publicId}`,
        method: 'PUT',
        data: data
    }

    axios.request(config)
        .then(response => callback({
            success: true,
            status: response.status,
        }))
        .catch(error => callback({
            success: false,
            status: error.response.status
        }));
}